import { render, staticRenderFns } from "./PendingApprovalsSummaryTable.vue?vue&type=template&id=09d9e490&scoped=true"
import script from "./PendingApprovalsSummaryTable.vue?vue&type=script&lang=js"
export * from "./PendingApprovalsSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./PendingApprovalsSummaryTable.vue?vue&type=style&index=0&id=09d9e490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d9e490",
  null
  
)

export default component.exports